<template>
  <button class="btn obituary share-cta" @click.prevent="initShare()">
    <svg viewBox="0 0 512 512">
      <use href="#share" />
    </svg>
    <span v-text="text" />
  </button>
</template>

<script>
import { initShare } from 'Main/share';

export default {
  name: 'ShareCta',

  data() {
    return {
      text: lavendlaObituary.common.share,
    };
  },

  methods: {
    initShare,
  },
};
</script>
